import { useTranslation } from '@flecto/translations'
import { type CoreProduct, type CoreItem } from '@flecto/types'

import { Badge, type BadgeProps } from '..'

export type BadgeItemInsuredProps = BadgeProps & {
  item:  CoreItem | CoreProduct
}

export function BadgeItemInsured({ item, ...props }: BadgeItemInsuredProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'items' })

  return (
    <Badge {...props} color={item.insured ? 'green' : 'gray.7'}>
      {t(item.insured ? 'label_yes' : 'label_no')}
    </Badge>
  )
}
